import { AbstractControl } from '@angular/forms';
import { defer, distinctUntilChanged, Observable, startWith } from 'rxjs';

/**
 * Create a deferred Observable of the given form `control`. This function should be use to observe values in forms.
 * @param control the control to observe
 * @returns an observable that produce values on change of `control`.
 */
export function valueChangesOf<T>(control: AbstractControl): Observable<T> {
  return defer(() => control.valueChanges.pipe(startWith(control.value), distinctUntilChanged()));
}
